import '../../BiosecurityWebSeries/Resources/resources.css'

const FirstWebinarResource = () => {
    return (
        <ul className= 'additional-resources' >
            <h3> Additional Resources: </h3>
            <li onClick = {() => window.open("https://ucanr.edu/sites/poultry/about/")}> UC ANR Poultry website  </li>
            <li onClick={() => window.open("https://linktr.ee/ucdpiteskylab")}> Pitesky lab Linktree </li>
            <li onClick={() => window.open("https://www.motomco.com/learning-center/farm-and-home-owners")}>Rodent control (Motomco) </li>
            <li onClick={() => window.open("https://www.aphis.usda.gov/aphis/ourfocus/animalhealth/animal-disease-information/avian/defend-the-flock-program/dtf-resources/dtf-resources")}> USDA-APHIS Defend the Flock - Resource Center </li>

            {/*Nested List */}

            <li onClick={()=> window.open("http://www.farad.org/")}> Food Animal Residue Avoidance Databank (FARAD) </li>
        </ul>
    )
}

export default FirstWebinarResource;